import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/layout/Sidebar';
import Topbar from './components/layout/Topbar';
import Toast from './components/ui/Toast';
import CampaignWizard from './components/campaigns/CampaignWizard';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import Journeys from './pages/Journeys';
import Segments from './pages/Segments';
import ABTests from './pages/ABTests';
import Push from './pages/Push';
import JourneyBuilder from './pages/JourneyBuilder';
import Login from './pages/Login';
import { authService } from './services/authService';
import './styles/tokens.css';
import './styles/global.css';

class Shell extends React.Component {
  render() {
    const { themeName, toggleTheme, location, onLogout } = this.props;
    return (
      <div className="shell">
        <Sidebar />
        <div className="main">
          <Topbar
            pathname={location.pathname}
            themeName={themeName}
            toggleTheme={toggleTheme}
            onLogout={onLogout}
          />
          <div className="page-body">
            <Routes>
              <Route path="/"          element={<Dashboard />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/campaigns" element={<Campaigns />} />
              <Route path="/campaigns/:id" element={<CampaignDetail />} />
              <Route path="/journeys"  element={<Journeys />} />
              <Route path="/segments"  element={<Segments />} />
              <Route path="/abtests"   element={<ABTests />} />
              <Route path="/push"              element={<Push />} />
              <Route path="/journeys/:id/builder" element={<JourneyBuilder />} />
            </Routes>
          </div>
        </div>
        <Toast />
        <CampaignWizard />
      </div>
    );
  }
}

function ShellWithLocation(props) {
  const location = useLocation();
  return <Shell {...props} location={location} />;
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { authed: authService.isAuthenticated() };
    this.handleLoggedIn = this.handleLoggedIn.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleUnauthorized = this.handleUnauthorized.bind(this);
  }

  componentDidMount() {
    window.addEventListener('pmw-click-frontend:unauthorized', this.handleUnauthorized);
  }

  componentWillUnmount() {
    window.removeEventListener('pmw-click-frontend:unauthorized', this.handleUnauthorized);
  }

  handleLoggedIn() {
    this.setState({ authed: true });
  }

  handleLogout() {
    authService.logout();
    this.setState({ authed: false });
  }

  handleUnauthorized() {
    this.setState({ authed: false });
  }

  render() {
    const { themeName, toggleTheme } = this.props;
    if (!this.state.authed) {
      return <Login onLoggedIn={this.handleLoggedIn} />;
    }
    return (
      <BrowserRouter>
        <ShellWithLocation themeName={themeName} toggleTheme={toggleTheme} onLogout={this.handleLogout} />
      </BrowserRouter>
    );
  }
}

export default App;
